import {
  decodeBase64,
  encodeBase64
} from '../'

// can use to save current cursor of a paginated list of results when clicking throught to a record's detail view
export const saveCursor = (startCursor) => {
  // a page's startCursor contains a number representing the first record after the previous page's last
  let record = parseInt(decodeBase64(startCursor), 10)
  // since query fetches records using 'after' parameter for cursor, we need to minus 1
  // otherwise we'll lose the first record of the new page of results
  return encodeBase64(record - 1, 'arrayconnection')
}

export const getPageCursor = (pageNumber, resultsPerPage) => (
  pageNumber === 1
    ? 'arrayconnection:null'
    : encodeBase64((pageNumber - 1) * resultsPerPage - 1, 'arrayconnection')
)

export class PageNavigationControl {
  constructor(firstPage = true, lastPage = false) {
    this._firstPage = firstPage
    this._lastPage = lastPage
    this._currentPage = 0
    this._pages = null
  }

  // getter/setter
  get firstPage() {
    return this._firstPage
  }
  set firstPage(status) {
    this._firstPage = status
  }

  get lastPage() {
    return this._lastPage
  }
  set lastPage(status) {
    this._lastPage = status
  }

  get currentPage() {
    return this._currentPage
  }
  set currentPage(page) {
    this._currentPage = page
  }

  get pages() {
    return this._pages
  }
  set pages(numberOfPages) {
    this._pages = numberOfPages
  }

  reset = () => {
    this.firstPage = true
    this.lastPage = false
    this.currentPage = 0
    this.pages = null
  }

  setPageStates = (currentPageData, nextPageData, states) => {
    if (states) {  // 'states' argument may be used to store nav info on navigation away and back from the page controlling page navigation
      this.firstPage = states.firstPage
      this.lastPage = states.lastPage
      this.currentPage = states.currentPage
      this.pages = states.pages
    } else if (currentPageData) {
      if (currentPageData.pageInfo.hasNextPage) {
        // paging forward
        if (nextPageData.pageInfo.hasNextPage) {
          // paging forward, no last page in sight
          this.lastPage = false
          this.firstPage = false
        }
        else if (nextPageData.pageInfo.hasPreviousPage) {
          // switched direction (go back)
          if (this.pages === this.currentPage) {
            this.lastPage = true
          }
        } else {
          // no next page (or went immediately back to first page)
          if (this.pages === null && this.currentPage !== 0) {
            this.pages = this.currentPage
            this.lastPage = true
          } else if (this.currentPage === this.pages) {
            this.lastPage = true
          } else if (this.currentPage === 0) {
            this.firstPage = true
          }
        }
      } else if (currentPageData.pageInfo.hasPreviousPage) {
        // page backward
        if (nextPageData.pageInfo.hasPreviousPage) {
          if (this.currentPage === 0) {
            this.firstPage = true
          } else {
            // paging backward, no first page in sight
            this.firstPage = false
            this.lastPage = false
          }
        } else {
          // switched direction (go forward)
          if (this.currentPage === 0) {
            // no previous page
            this.firstPage = true
          } else if (this.currentPage === this.pages) {
            this.lastPage = true
          }
        }
      } else {
        // check if on first page
        if (this.currentPage === 0) {
          this.firstPage = true
        }

        // check if on last page
        if (this.currentPage === this.pages ||
          // or in the case of same first page data was loaded
          (!currentPageData.pageInfo.hasPreviousPage &&
            !currentPageData.pageInfo.hasNextPage &&
            !nextPageData.pageInfo.hasPreviousPage &&
            !nextPageData.pageInfo.hasNextPage)
        ) {
          this.lastPage = true
        }
      }
    }
    else if (!nextPageData.pageInfo.hasNextPage){
      // on first & last page
      this.lastPage = true
    }
  }

  nextPage = (loadNext, ...args) => {  // args could include any params necessary for load next page function
    loadNext(...args)
    this.firstPage = false
    this.currentPage += 1
  }

  previousPage = (loadPrevious, ...args) => {
    loadPrevious(...args)
    this.lastPage = false
    this.currentPage -= 1
  }
}



// WEBPACK FOOTER //
// ./src/utils/pagination/index.js